import { HttpNoData } from "../core";


/**
 * 
 * @param {Number} shopId 
 * @param {string} jwt 
 * @returns {Promise<number[]>}
 */
export function getSidesOnDraftShopAsync(shopId, jwt) {
    return HttpNoData(`/api/medals/v1/drafts/shop/${shopId}/sides`, 'GET', jwt)
        .then(res => res.json());
}